export default __webpack_public_path__ + "static/media/bgCheck.8b1f4ffb.png";